import React, {  Component } from 'react';

export default class RequestReturnFileWarningDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog:false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('RequestReturnFileWarningDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    {this.props.success?<h2 className="title">SUCCESS</h2>:<h2 className="title">WARNING</h2>}
                    <p className={this.props.success?"":"bold red"} style={{ marginTop: '1px', textTransform:"uppercase"}}>
                        {this.props.content}
                    </p>
            	</div>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestReturnFileWarningDialog.js